import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import useOrgTemplateFindById from '@opsbase/react-gql-hooks/orgtemplate/useOrgTemplateFindById';
import useOrgTemplateUpdate from '@opsbase/react-gql-hooks/orgtemplate/useOrgTemplateUpdate';
import Dialog from '@opsbase/web-dialogs/Dialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import useParams from '@opsbase/web-nav/useParams';
import React, { useCallback } from 'react';
import OpDefinitionEditWorkflowsTab from '../opdefinition/OpDefinitionEditWorkflowsTab';
import OrgTemplateEditConstraintsTab from './OrgTemplateEditConstraintsTab';
import OrgTemplateEditSettingsTab from './OrgTemplateEditSettingsTab';
export function OrgTemplateEditDialog() {
    const { id } = useParams();
    const updateOrgTemplate = useOrgTemplateUpdate();
    const { loading, data } = useOrgTemplateFindById({ variables: { id } });
    const handleChangeTitle = useCallback(title => {
        updateOrgTemplate({
            id,
            patch: { title },
        }, {
            optimisticResponse: {
                __typename: 'Mutation',
                updateOrgTemplate: {
                    __typename: 'OrgTemplate',
                    ...data,
                    title,
                },
            },
        }).catch(doNothing);
    }, [data, id, updateOrgTemplate]);
    if (loading || !data)
        return null;
    return (React.createElement(Dialog, { size: DialogSize.XFULL_YFULL, editableTitle: true, title: data ? data.title : i18n.t('loading'), onChangeTitle: handleChangeTitle, padded: false, scroll: false, tabs: [
            {
                default: true,
                label: i18n.t('form-constraints'),
                route: 'constraints',
                component: () => React.createElement(OrgTemplateEditConstraintsTab, { template: data }),
            },
            {
                label: i18n.t('settings'),
                route: 'settings',
                component: () => React.createElement(OrgTemplateEditSettingsTab, { template: data }),
            },
            {
                label: i18n.t('business-rules'),
                route: 'business-rules',
                component: () => (React.createElement(OpDefinitionEditWorkflowsTab, { definition: data, type: 'template' })),
            },
        ] }));
}
export default OrgTemplateEditDialog;
